<template>
    <div class="mc-selectbox-pane" v-show="show">
        <ul>
            <slot></slot>
        </ul>
        <slot name="footer"></slot>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'pane',
        inject: ['select'],
        props:{
            name: {
                type: String
            },
            label: {
                type: String,
                default: ''
            }
        },
        data(){
            return {
                show: true
            }
        },
        methods: {
            updateNav(){
                this.$parent.updateNav();
            }
        },
        watch: {
            label(){
                this.updateNav();
            }
        },
        created(){
          this.select.dropdownScroll = false
        },
        mounted(){
            this.updateNav()
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/base-selectbox-pane.vue